import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DateRange,
  extractDateRange,
  HxCurrencyPipe,
  HxFixedPipe,
  HxMoneyFormatPipe,
  HxReportService,
  HxUiLabelPipe,
  isoDate,
  StatisticsCategoryProductSalesModel,
  toRouterQueryParams
} from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { subDays, subMonths } from 'date-fns';
import { Subscription } from 'rxjs';
import { HxDateRangeSelectComponent, HxLoaderComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-product-category-sales',
    templateUrl: './product-category-sales.component.html',
    styleUrls: ['./product-category-sales.component.css'],
    imports: [HxDateRangeSelectComponent, FormsModule, NgIf, NgFor, NgClass, RouterLink, HxLoaderComponent, TranslocoPipe, HxCurrencyPipe, HxUiLabelPipe, HxFixedPipe, HxMoneyFormatPipe]
})
export class ProductCategorySalesComponent implements OnInit, OnDestroy {
  sales: StatisticsCategoryProductSalesModel[] = [];
  storeIds: number[] = [];
  params: {
    date?: DateRange,
  }= {};
  isloading = {
    sales: false,
  };
  totalAmount: number = 0;
  totalCostPrice: number = 0;
  total: number = 0;
  totalProfit: number = 0;
  private sub!: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.sub = this.aRoute.queryParamMap.subscribe(async paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(subDays(subMonths(new Date(), 1), 1)), to: isoDate(subDays(new Date(), 1))};
      this.loadProductCategories();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  applyFilters() {
    this.navigate();
  }

  private navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private async loadProductCategories() {
    this.sales = [];
    this.isloading.sales = true;
    try {
      const sales = await this.reportService.getStatisticsCategoryProductSales({fromDate: this.params.date.from, toDate: this.params.date.to, storeIds: this.storeIds });
      if (sales.length > 0) {
        this.sales = sales;
        this.totalAmount = this.sales.reduce((a, b) => a + b.amountTotal, 0);
        this.total = this.sales.reduce((a, b) => a + b.valueTotal, 0);
        this.totalProfit = this.sales.reduce((a, b) => a + (b.valueTotal - b.costPriceTotal), 0);
        this.totalCostPrice = this.sales.reduce((a, b) => a + b.costPriceTotal, 0);
      } else {
        this.sales = [];
      }
    } finally {
      this.isloading.sales = false;
    }
  }
}
